import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'

type Props = {
  [label: `label${number}`]: React.ReactNode
  leadingIcon?: React.ReactNode
}

const LabelContainer = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;

  > :first-child:not(li) {
    margin-right: ${rem(8)};
  }

  > li {
    &::before {
      content: '•';
      margin: 0 ${rem(4)};
    }

    &:first-of-type::before {
      content: '';
      margin: 0;
    }

    &:empty {
      display: none;
    }
  }
`

function TripItemLabel({ leadingIcon, ...labels }: Props) {
  return (
    <LabelContainer>
      {leadingIcon}
      {Object.entries(labels).map(([key, value]) => (
        <BodyText as="li" key={key} variant="small">
          {value}
        </BodyText>
      ))}
    </LabelContainer>
  )
}

export default React.memo(TripItemLabel)
